/**
 * Normalizes a phone value to a dialable US number.
 *
 * @param {string|number|null|undefined} value
 * @returns {string|null}
 */
export default function toDialableNumber(value) {
  if (value === null || value === undefined) return null;
  const text = String(value).trim();
  if (!text) return null;
  // Agent/sip URIs are never dialable customer numbers.
  if (/^[a-z]+:/i.test(text)) return null;
  const digits = text.replace(/\D/g, '');
  if (digits.length === 10) return digits;
  if (digits.length === 11 && digits.startsWith('1')) return digits.slice(1);
  return null;
}
